export default {
    youHave: 'You have',
    todoItems: 'new task',
    batchSuccess: 'workitem have been batched',
    batchFail: 'workitem have been unsuccessfully batched ',
    batchProcess: 'batch approve workitem ，please wait',
    failReason: 'Failure Reason',
    attachment: 'Attachment',
    signature: 'signature by hand',
    approveFail: 'do not pass approve',
    approveSuggestion: 'Approve Suggestion',
    noBatchWorkitemTip: 'todo items don\'t includes batch tasks,user can not toggle batch mode',
    unselectWorkitem: 'unselect workitem',
    timeOut: 'Timeout',
    goingTimeOut: 'later,it will timeout',
    timeoutLater: 'later,it will timeout',
    haveWaitFor: 'Waited For',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Mins',
    lessOneMinute: 'less to 1 min',
    batch: 'Batch',
    batchApprove: 'Batch Approve',
    selectAll: 'Choose all',
    completed: 'Completed',
    haveSelected: 'Choosed',
    markMultiRead: 'Mark to read',
    toreadItems: 'new read task',
    notSelectUnread: 'Please choose the unread item~',
    reciveTime: 'Recive Time',
    approvalTime: 'Approve Time',
    agree: 'Approve',
    reject: 'Reject',
    forward: 'Transfer',
    canceled: 'Cancel',
    unresolved: 'Processing',
    readTime: 'Read Time',
    curActivity: 'Current Activities',
    stayTime: 'Stayed Time',
    batchHandle: 'Batch Handle',
    cancelBatch: 'Cancel Batch',
    templateName: 'Workflow Template',
    flowItems: 'workfolw items',
    commonFlow: 'Commonly Use Workflow',
    haveSearch: 'Search for',
    items: ' results',
    historySearch: 'History search',
    beUrged: 'Urged',
    loadAllWorkflow: 'All processes loaded',
    usedTime: 'usedTime:',
    costTime: 'costTime:',
    finishTime: 'finishTime:',
    cancelTime: 'cancelTime:',
    resolveTime: 'Action Time',
};
